import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../assets/styles/Mail.module.scss'; // Use the same style as VerifyEmail for consistency

const PreRegisterThanks: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.containerWrap}>
      <div className={styles.backgroundGlow}>
        <div className={styles.glowBlue} />
        <div className={styles.glowPink} />
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <div className={styles.resultCard}>
              <img src="/images/logo_aibex_line_b.svg" alt="AI-BEX" className={styles.logo} />

              <h1>仮登録を受け付けました</h1>
              <p className={styles.description}>
                ご入力いただいたメールアドレス宛に<br />
                本人確認用のメールを送信いたしました。<br /><br />
                メール内のリンクをクリックして、<br />
                メールアドレスの認証を完了してください。
              </p>
              <button onClick={() => navigate('/login')}>
                ログイン画面へ戻る
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreRegisterThanks;
